import { render, staticRenderFns } from "./checklist-editor.vue?vue&type=template&id=19529823&"
import script from "./checklist-editor.vue?vue&type=script&lang=js&"
export * from "./checklist-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports